import React from "react";
import { Link } from "react-router-dom";

export default function Cardforwork(props) {
  return (
    <div>
      <div className="card shadow card-project">
        {props.imgsrc && (
          <img
            src={props.imgsrc}
            className="card-img-top d-sm-block"
            alt="img-tictactoe"
          />
        )}
        <div className="card-body">
          <h5 className="card-title">
            <strong>{props.title}</strong>
          </h5>
          <p className="card-text text-muted">{props.about}</p>
          {props.tech && (
            <h6 className="mb-3">
              <i className="ri-verified-badge-line iconf"></i> {props.tech}
            </h6>
          )}

          {props.price && (
            <h6>
              <i className="ri-money-rupee-circle-line iconf"></i> {props.price}
            </h6>
          )}
          {props.buy && (
            <Link to={props.buy} className="btn">
              Buy
            </Link>
          )}
          <div className="d-flex justify-content-between mt-2">
            {props.weburl && (
              <a
                href={props.weburl}
                className="btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Explore
              </a>
            )}

            {props.status && (
              <div className={`status-badge ${props.status.toLowerCase()}`}>
                <span className="status-dot"></span>
                {props.status === "operational" ? "Operational" : "Building"}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
